import React from 'react';
import cn from 'classnames';

interface Props {
  className?: String;
}

const BottomInfo: React.FC<Props> = ({ className }) => {
  return (
    <>
      <div
        style={{ border: '0.25px solid black' }}
        className={cn(className)}></div>
      <p>소개 : </p>
    </>
  );
};
export default BottomInfo;
